import React, { useState } from 'react'

import Text from 'components/common/Text'
import PaginationPortal from 'components/ControlBar2.0/BottomControlBar/components/PaginationPortal'
import { dispatchHandleFullScreenToggle } from 'store/dispatcher'

import usePagination from './hooks/usePagination'
import Students from './Students'
import { Container, Sections, Wrappers, Pagination } from './styles'
import TeacherTileToggler from './TeacherTileToggler'

import TeacherPlaceholder from '../TeacherPlaceholder'

const BASE = 'assets/revamp'

const RoomLayoutWeb = ({ students = [], teacher = null }) => {
    const [isTeacherFullScreen, setTeacherFullScreen] = useState(false)
    const toggleFullScreen = () => {
        dispatchHandleFullScreenToggle(isTeacherFullScreen)
        setTeacherFullScreen(!isTeacherFullScreen)
    }

    const {
        up,
        down,
        totalPages,
        currentPage,
        upDisabled,
        downDisabled,
        studentsToDisplay,
    } = usePagination({ students })
    const studentElems = students?.length <= 6 ? students : studentsToDisplay
    const studentsCount = studentElems?.length
    const hasTeacherJoined = !!teacher

    const teacherElem = (
        <Sections.Teacher className="teacher-section">
            <Wrappers.Teacher
                hasTeacherJoined={hasTeacherJoined}
                studentsCount={studentsCount}
            >
                {hasTeacherJoined ? (
                    <>
                        <TeacherTileToggler
                            isFullScreen={isTeacherFullScreen}
                            toggle={toggleFullScreen}
                        />
                        {teacher}
                    </>
                ) : (
                    <TeacherPlaceholder />
                )}
            </Wrappers.Teacher>
        </Sections.Teacher>
    )

    const paginationButtons =
        !isTeacherFullScreen && students?.length > 6 ? (
            <PaginationPortal>
                <Pagination.Area>
                    <Pagination.Button
                        disabled={upDisabled}
                        src={`${BASE}/arrow-up.svg`}
                        alt="scroll-up"
                        onClick={up}
                    />
                    <span>
                        <Text level="3" color="#ffffffdb">
                            {currentPage}/{totalPages}
                        </Text>
                    </span>
                    <Pagination.Button
                        disabled={downDisabled}
                        src={`${BASE}/arrow-down.svg`}
                        alt="scroll-down"
                        onClick={down}
                    />
                </Pagination.Area>
            </PaginationPortal>
        ) : null

    return (
        <Container
            isTeacherFullScreen={isTeacherFullScreen}
            studentsCount={studentsCount}
        >
            <Students students={studentElems} />
            {teacherElem}
            {paginationButtons}
        </Container>
    )
}

export default RoomLayoutWeb
